const TOKEN_KEYS = {
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  TEMP_TOKEN: "temp_token",
};

export const getAccessToken = (): string => localStorage.getItem(TOKEN_KEYS.ACCESS_TOKEN) ?? "";

export const getRefreshToken = (): string =>
  localStorage.getItem(TOKEN_KEYS.REFRESH_TOKEN) ?? "";

export const getTempToken = (): string =>
  localStorage.getItem(TOKEN_KEYS.TEMP_TOKEN) ?? "";

export const saveAuthTokens = (jwt: string, refreshToken: string): void => {
  localStorage.setItem(TOKEN_KEYS.ACCESS_TOKEN, jwt);
  localStorage.setItem(TOKEN_KEYS.REFRESH_TOKEN, refreshToken);
  localStorage.removeItem(TOKEN_KEYS.TEMP_TOKEN);
};

export const saveTempToken = (tempToken: string): void => {
  localStorage.setItem(TOKEN_KEYS.TEMP_TOKEN, tempToken);
};

export const clearAuthTokens = (): void => {
  localStorage.removeItem(TOKEN_KEYS.ACCESS_TOKEN);
  localStorage.removeItem(TOKEN_KEYS.REFRESH_TOKEN);
};

export const clearTempToken = (): void => {
  localStorage.removeItem(TOKEN_KEYS.TEMP_TOKEN);
};
